
<template>
	<div v-if="app && app.strategy">
		<h3>{{header}}</h3>
		<section class="section-body">
			<table class="requirements-table">
				<thead>
					<tr>
						<td>Name</td>
						<td>Required</td>
						<td>Authorized On</td>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{{ app.name }}</td>
						<td>Required</td>
						<td v-if="appIdentity">
							{{ appIdentity.createdOn | date('long') }}
						</td>
						<td v-else>
							-
						</td>
					</tr>
				</tbody>
			</table>
		</section>
	</div>
</template>

<script>
	import Vue from 'vue';
	import date from '../filters/date';

	export default {
		name: 'AuthAppDetails',
		filters: {
			date
		},
		props: {
			app: Object,
			appIdentity: Object,
			header: { type: String, default: "Auth" }
		},
	};
</script>

<style scoped>

	.section-body{
		background-color: #EDF0F3;
		overflow: hidden;
		padding:10px;
		border-radius:3px;
		/* border: 1px solid #e3e6ea; */
		background-color: #EDF0F3;
	}
	table {
		width: 100%;
		background-color: white;
		overflow:hidden;

	}
	tbody tr:last-of-type{
		border-bottom-right-radius: 4px;
	}
	th{
		white-space: nowrap;
	}
	th, td{
		padding: 10px;
		font-size:12px;
	}
	table tr:last-child td:first-child {
		border-bottom-left-radius: 5px 10px;
	}

	table tr:last-child td:last-child {
		border-bottom-right-radius: 10px;
	}

	thead tr{
		font-weight: 600;
		color: #777;
	}

		/* // Extra small devices (portrait phones, less than 576px) */
	@media (max-width: 575.98px) {
		.section-body{
			overflow: scroll;
		}
	}

	/* // Small devices (landscape phones, 576px and up) */
	@media (min-width: 576px) and (max-width: 767.98px) {
		.section-body{
			overflow: scroll;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/AuthAppDetails.vue